<template>
  <div class="step-two-content">
    <div class="row periods-row">
      <div
          v-for="(period, index) in periods" :key="index" class="period-wrapper"
          v-bind:class="{
            popular: isPopular(index),
            profitable: isProfitable(index),
            active : isActive(index)
          }"
          v-on:click="selectPeriod(index)"
      >
        <div class="period-label" v-if="isPopular(index)">Najpopularniejszy</div>
        <div class="period-label" v-if="isProfitable(index)">Najbardziej opłacalny</div>
        <div class="period-content">
          <div class="period-chosen"></div>
          <div class="period-name">{{ period.name }}</div>
          <div class="period-line"></div>
          <div class="price-wrapper" v-if="period.pricePromo">
            <div class="price-with-out-discount-label">
              <span>{{ period.priceMonthly }}</span> PLN/netto
            </div>
            <div class="price">
              <span class="price-month">{{ toFixedTwo(period.priceMonthlyPromo) }}</span>
              <span class="price-sufix">
                <span>PLN</span><br>
                netto/m-c
              </span>
            </div>
          </div>
          <div class="price-wrapper" v-else>
            <div class="price-with-out-discount-label"></div>
            <div class="price">
              <span class="price-month">{{ toFixedTwo(period.priceMonthly) }}</span>
              <span class="price-sufix">
                <span>PLN</span><br>
                netto/m-c
              </span>
            </div>
          </div>
          <div class="price-discount">
            {{ priceSaveUpText(period.priceSaveUp) }}
            <span v-if="period.pricePromo" class="price-discount-percent">(-{{ period.pricePromoPercent }}%)</span>
          </div>
        </div>
      </div>
    </div>
    <div class="step-dashed">
      Interesuje Cię dłuższy plan?
      <span class="step-highlight step-highlight-call"><img src="@/assets/img/common/iconmonstr-phone-3-green.svg" height="15" width="15"> Zadzwoń +48 783 539 157</span>
    </div>
    <div v-if="getShowAdditionalDays" class="step-dashed">
      <span>Twój nowy plan będzie aktywny do</span>
      <span class="step-highlight">{{ planEndDate }}</span>
    </div>

    <div class="button-wrapper">
      <router-link :to="{ name: 'PaymentStepPlan' }" class="back-step-button">Cofnij</router-link>
      <router-link :to="{ name: 'PaymentStepExtra' }" class="next-step-button button">Kontynuuj</router-link>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import mixin from '@/mixin'
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'PaymentStepPeriod',
  mixins: [mixin],
  computed: {
    ...mapState([
      'user',
      'plans',
      'selectedPlanIndex',
      'selectedPeriodIndex',
      'selectedPackageId'
    ]),
    ...mapGetters([
      'getAdditionalDays',
      'getShowAdditionalDays',
      'selectedPeriod'
    ]),
    periods: function () {
      return this.plans[this.selectedPlanIndex].periods
    },
    planEndDate: function () {
      let now = moment()
      let period = this.selectedPeriod
      let days = period.days + this.getAdditionalDays
      return now.add(days, 'days').format('DD-MM-YYYY')
    }
  },
  methods: {
    ...mapMutations([
      'selectPeriod'
    ]),
    isPopular: function (index) {
      let period = this.periods[index]
      if (period.days === 180) {
        return true
      } else {
        return false
      }
    },
    isProfitable: function (index) {
      if (this.periods.length - 1 === index) {
        return true
      } else {
        return false
      }
    },
    isActive: function (index) {
      return this.selectedPeriodIndex === index
    },
    priceSaveUpText: function (price) {
      if (price) {
        return 'Oszczędzasz ' + price + 'zł'
      } else {
        return 'Cena referencyjna'
      }
    }
  },
  created: function () {
    if (this.$store.state.selectedPeriodIndex === null && this.periods.length > 0) {
      this.$store.commit('selectPeriod', this.periods.length - 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row {
  justify-content: center;
}
.periods-row .period-wrapper {
  padding: 0 10px 0 10px;
}
.periods-row .period-wrapper:first-child {
  padding-left: 0;
}
.periods-row .period-wrapper:last-child {
  padding-right: 0;
}
.period-content {
  align-items: center;
  background-color: #FFFFFF;
  border-left: 0 solid transparent;
  border-top: 0 solid transparent;
  border-right: 0 solid transparent;
  border-bottom: 0 solid transparent;
  box-shadow: 0 5px 10px 0 rgba(0,0,0,0.1);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto-Regular';
  height: 157px;
  margin: 80px 0 10px 0;
  padding: 25px 0 25px 0;
  position: relative;
  transition: all 0.3s ease-out;
  width: 230px;
  border: 4px solid #fff;
  border-radius: 5px;
}
.period-content:hover {
  background-color: #f9f9f9;
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.3);
}
.period-wrapper.popular .period-content  {
  border-top: 3px solid #E90855;
  margin-top: 8px;
}
.period-wrapper.profitable .period-content  {
  border-top: 3px solid #41CDA8;
  margin-top: 8px;
}
.period-label {
  font-size: 12px;
  font-family: 'Roboto-Regular';
  margin: 18px 0 0 0;
  padding: 39px 0 0 0;
  text-align: center;
  text-transform: uppercase;
}
.price-with-out-discount-label {
  font-weight: 500;
}
.period-wrapper.popular .period-label {
  background: url(../../assets/img/common/icon_popular.png) center top no-repeat;
  color: #E90855;
}
.period-wrapper.popular.active .period-label {
  color: #E90855;
}
.period-wrapper.profitable .period-label {
  background: url(../../assets/img/common/icon_profitable.png) center top no-repeat;
  color: #41CDA8;
}
.period-wrapper.active .period-content {
  border: 4px solid #41CDA8;
  border-radius: 5px;
  color: #41CDA8;
  /* height: 157px; */
  /* margin: 60px 0 10px 0;
  padding: 41px 0 18px 0; */
  /* margin: 80px 0 10px 0;
  padding: 25px 0 25px 0; */
  /* width: 240px; */
}
/* .period-wrapper.active.popular .period-content,
.period-wrapper.active.profitable .period-content {
  margin: 10px 0 10px 0;
  padding: 41px 0 21px 0;
} */
.period-wrapper .period-content .period-chosen {
  background: url(../../assets/img/common/icon_selected.svg) center top no-repeat;
  position: absolute;
  top: -17px;
  left: 226px;
  width: 30px;
  height: 40px;
  transition: all 0.3s ease-out;
  opacity: 0;
}
.period-wrapper.active .period-content .period-chosen {
  background: url(../../assets/img/common/icon_selected.svg) center top no-repeat;
  position: absolute;
  top: -17px;
  left: 216px;
  width: 30px;
  height: 40px;
  transition: opacity 0.2s linear;
  opacity: 1;
}
.period-name {
  color: #000000;
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
  text-transform: uppercase;
}
.period-wrapper.active .period-name{
  color: #41CDA8;
  font-weight: 700;
}
.period-line {
  background-color: #CDCDCD;
  height: 1px;
  margin-bottom: 17px;
  width: 160px;
}

.price{
  margin-bottom: 15px;
}
.price-month{
  color: #E90855;
  font-size: 24px;
  font-weight: 300;
}
.active .price-month {
  font-weight: 700;
}
.price-sufix{
  color: #7C7C7C;
  display: inline-block;
  font-size: 10px;
  padding-left: 3px;
}
.price-discount {
  background-color: #F5F5F5;
  border-radius: 10px;
  color: #999999;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  width: 180px;
}
.price-discount-percent {
  color: #41CDA8;
  font-family: 'Roboto-Regular';
  font-weight: 700;
}
.step-highlight {
  color: #41CDA8;
  font-family: 'Roboto-Regular';
  font-weight: 700;
  padding-left: 20px;
}
.step-highlight-call {
  /*background: url(../../assets/img/common/iconmonstr-phone-3-green.svg) left top no-repeat;*/
  background-size: contain, cover;
}
.step-dashed {
  border: 2px dashed #E6E6E6;
  color: #999999;
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 20px 0;
  padding: 15px;
  text-align: center;
}
@media screen and (max-width: 480px) {
  .period-content {
    margin-top: 10px;
  }
  .period-wrapper.active .period-content {
    margin-top: 20px;
  }
  .active.popular .period-label, .active.profitable .period-label {
    margin-top: 10px;
  }
  .step-dashed{
    margin: 20px 0 20px 0;
  }
  .button-wrapper{
    justify-content: center;
  }
  .step-highlight-call {
    display: block;
  }
}
</style>
